import React from 'react';
import List from './List';
import './styles.scss';

export default function WorkOrkerType(): JSX.Element {
  return <List />;
}
